var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "browse-sidebar", style: _vm.panelStyle }, [
    _c("div", {
      staticClass: "browse-sidebar-resize-handle",
      class: { "is-left": _vm.isLeft },
      on: { mousedown: _vm.onResizeStart },
    }),
    _c(
      "div",
      { staticClass: "browse-sidebar-inner" },
      [
        _c("div", { staticClass: "browse-sidebar-header" }, [
          _c("div", { staticClass: "browse-sidebar-heading" }, [
            _c(
              "div",
              {
                staticClass: "browse-sidebar-title",
                attrs: { title: _vm.title },
              },
              [_vm._v(_vm._s(_vm.title))]
            ),
            _vm.subtitle
              ? _c(
                  "div",
                  {
                    staticClass: "browse-sidebar-subtitle",
                    attrs: { title: _vm.subtitle },
                  },
                  [_vm._v(_vm._s(_vm.subtitle))]
                )
              : _vm._e(),
            _vm.selectedCount > 1
              ? _c("div", { staticClass: "browse-sidebar-subtitle" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$ct("sidebar.showing-last-of", {
                        count: _vm.selectedCount,
                      })
                    )
                  ),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "browse-sidebar-actions" },
            [
              _vm.item && _vm.canEdit
                ? _c(
                    "w-link",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("sidebar.edit"),
                          expression: "$ct('sidebar.edit')",
                        },
                      ],
                      staticClass: "browse-sidebar-action",
                      on: { click: _vm.edit },
                    },
                    [_c("w-fa", { attrs: { icon: "pen" } })],
                    1
                  )
                : _vm._e(),
              _vm.menuItems.length > 0
                ? _c(
                    "w-menu",
                    {
                      attrs: {
                        "close-on-blur": "",
                        "close-on-click": "",
                        right: "",
                      },
                      model: {
                        value: _vm.menuOpen,
                        callback: function ($$v) {
                          _vm.menuOpen = $$v
                        },
                        expression: "menuOpen",
                      },
                    },
                    [
                      _c(
                        "w-link",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("sidebar.more"),
                              expression: "$ct('sidebar.more')",
                            },
                          ],
                          staticClass: "browse-sidebar-action",
                          attrs: { slot: "activator" },
                          slot: "activator",
                        },
                        [_c("w-fa", { attrs: { icon: "ellipsis-h" } })],
                        1
                      ),
                      _c(
                        "w-transition-slide-height",
                        [
                          _vm.menuOpen
                            ? _c(
                                "w-scroll-view",
                                {
                                  staticClass: "w-dropdown-select-items",
                                  attrs: {
                                    "rounded-bottom": "",
                                    "rounded-top": "",
                                  },
                                },
                                _vm._l(_vm.menuItems, function (action, i) {
                                  return _c(
                                    "div",
                                    {
                                      key: "m" + i,
                                      staticClass: "w-dropdown-select-item",
                                      attrs: { tabindex: "0" },
                                      on: {
                                        click: function ($event) {
                                          return action.value()
                                        },
                                      },
                                    },
                                    [
                                      _c("w-fa", {
                                        staticClass:
                                          "mr browse-sidebar-menu-icon",
                                        attrs: { icon: action.icon },
                                      }),
                                      _vm._v(_vm._s(action.text) + " "),
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-link",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("sidebar.close"),
                      expression: "$ct('sidebar.close')",
                    },
                  ],
                  staticClass: "browse-sidebar-action",
                  on: { click: _vm.close },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          ),
        ]),
        _c(
          "w-scroll-view",
          { staticClass: "browse-sidebar-content" },
          [
            !_vm.item
              ? _c("div", { staticClass: "browse-sidebar-empty" }, [
                  _vm._v(" " + _vm._s(_vm.$ct("sidebar.select-a-row")) + " "),
                ])
              : [
                  _vm.blocks.length == 0
                    ? _c(
                        "div",
                        { staticClass: "browse-sidebar-empty" },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$ct("sidebar.no-blocks")) + " "
                          ),
                          _vm.canEditView
                            ? _c("w-link", { on: { click: _vm.configure } }, [
                                _vm._v(_vm._s(_vm.$ct("sidebar.configure"))),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._l(_vm.blocks, function (block) {
                    return _c("app-browse-sidebar-block", {
                      key: block.uid,
                      attrs: { block: block, item: _vm.item, state: _vm.state },
                    })
                  }),
                ],
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }